import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { AlertComponent } from '../../lib/alert/alert.component'
import { NotificationFlashComponent } from './notification-flash.component'

/**
 * This module contains reusable notification components
 */
@NgModule({
  imports: [CommonModule, AlertComponent, NotificationFlashComponent],
  declarations: [],
  exports: [AlertComponent, NotificationFlashComponent],
})
export class NotificationModule {}
